/* NOYA — interacciones (vanilla JS, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.ny-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ny-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ny-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Contadores ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = (target % 1 === 0) ? Math.round(val).toLocaleString('es-MX') : val.toFixed(1);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = (target % 1 === 0) ? target.toLocaleString('es-MX') : target.toFixed(1);
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { var t = parseFloat(n.getAttribute('data-count')); n.textContent = t.toLocaleString('es-MX'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Acordeón FAQ ---- */
  function initFaq() {
    var items = document.querySelectorAll('.ny-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.ny-faq__q');
      var a = item.querySelector('.ny-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('ny-open');
        item.classList.toggle('ny-open');
        q.setAttribute('aria-expanded', String(!open));
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
      });
    });
  }

  /* ---- Parallax suave del hero ---- */
  function initParallax() {
    if (reduce) return;
    var nodes = document.querySelectorAll('[data-parallax]');
    if (!nodes.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        nodes.forEach(function (n) {
          var speed = parseFloat(n.getAttribute('data-parallax')) || 0.1;
          n.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var main = document.getElementById('ny-pdp-main');
    var thumbs = document.querySelectorAll('.ny-pdp__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var wrap = document.querySelector('.ny-pdp__options');
    if (!wrap) return;
    var variants;
    try { variants = JSON.parse(wrap.getAttribute('data-variants')); } catch (e) { return; }
    var form = document.querySelector('.ny-pdp__form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.getElementById('ny-pdp-price');
    var addBtn = document.getElementById('ny-pdp-add');
    var selected = {};
    wrap.querySelectorAll('.ny-pdp__chip.is-active').forEach(function (c) { selected[c.getAttribute('data-opt')] = c.getAttribute('data-val'); });

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + ' MXN';
    }
    function update() {
      var match = variants.find(function (v) {
        return (!selected['1'] || v.option1 === selected['1']) &&
               (!selected['2'] || v.option2 === selected['2']) &&
               (!selected['3'] || v.option3 === selected['3']);
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) html += '<del>' + money(match.compare_at_price) + '</del>';
        html += '<span>' + money(match.price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        var span = addBtn.querySelector('span');
        if (span && !match.available) span.textContent = 'Agotado';
      }
    }
    wrap.querySelectorAll('.ny-pdp__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var opt = chip.getAttribute('data-opt');
        wrap.querySelectorAll('.ny-pdp__chip[data-opt="' + opt + '"]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        selected[opt] = chip.getAttribute('data-val');
        update();
      });
    });
  }

  /* ---- Agregar al carrito rápido (sin recargar) ---- */
  function getToast() {
    var t = document.querySelector('.ny-toast');
    if (t) return t;
    t = document.createElement('div');
    t.className = 'ny-toast';
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="m9 16.2-3.5-3.5L4 14.2l5 5 11-11-1.5-1.5z"/></svg><span class="ny-toast__msg"></span> <a href="/cart">Ver carrito</a>';
    document.body.appendChild(t);
    return t;
  }
  function showToast(msg) {
    var t = getToast();
    t.querySelector('.ny-toast__msg').textContent = msg;
    t.classList.add('is-show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-show'); }, 3500);
  }
  function refreshCartCount() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (cart) {
      var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble');
      bubbles.forEach(function (b) { if (b.children.length === 0) b.textContent = cart.item_count; });
    }).catch(function () {});
  }
  function initQuickAdd() {
    var buttons = document.querySelectorAll('.ny-gcard__add[data-add-id]');
    if (!buttons.length) return;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-add-id');
        if (!id || btn.dataset.loading === '1') return;
        btn.dataset.loading = '1';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function (data) {
          btn.dataset.loading = '0';
          if (data && data.status) { showToast('No se pudo agregar. Intenta de nuevo.'); return; }
          btn.classList.add('is-added');
          var span = btn.querySelector('span');
          var prev = span ? span.textContent : '';
          if (span) span.textContent = '¡Agregado!';
          showToast('Producto agregado al carrito');
          refreshCartCount();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { btn.classList.remove('is-added'); if (span) span.textContent = prev; }, 2000);
        }).catch(function () { btn.dataset.loading = '0'; showToast('No se pudo agregar. Intenta de nuevo.'); });
      });
    });
  }

  /* ---- Puntos interactivos de producto ---- */
  function initSpots() {
    var card = document.querySelector('.ny-spotcard');
    if (!card) return;
    var content = card.querySelector('.ny-spotcard__c');
    document.querySelectorAll('.ny-spot').forEach(function (s) {
      s.addEventListener('click', function () {
        var id = 'ny-spot-' + s.getAttribute('data-spot');
        var tpl = document.getElementById(id);
        if (!tpl) return;
        if (card.dataset.open === id && !card.hidden) {
          card.hidden = true; card.dataset.open = '';
          return;
        }
        content.innerHTML = tpl.innerHTML;
        card.hidden = false; card.dataset.open = id;
      });
    });
    var x = card.querySelector('.ny-spotcard__x');
    if (x) x.addEventListener('click', function () { card.hidden = true; card.dataset.open = ''; });
  }

  function init() { initReveals(); initCounters(); initFaq(); initParallax(); initGallery(); initVariants(); initQuickAdd(); initSpots(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
